import { __awaiter, __generator } from "tslib";
import { defineStore } from 'pinia';
import { login, logout, checkAuth } from '@/api/auth';
export var useAuthStore = defineStore('auth', {
    state: function () { return ({
        loading: false,
        user: null,
        orders: [],
    }); },
    actions: {
        login: function (email, password) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, login(email, password)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.fetchUser()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        fetchUser: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            this.loading = true;
                            return [4 /*yield*/, checkAuth()];
                        case 1:
                            response = _a.sent();
                            this.user = response.data;
                            return [3 /*break*/, 4];
                        case 2:
                            err_1 = _a.sent();
                            this.user = null;
                            return [3 /*break*/, 4];
                        case 3:
                            this.loading = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        logout: function () {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, logout()];
                        case 1:
                            _a.sent();
                            this.user = null;
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error('Logout failed', error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        addOrder: function (gid) {
            this.orders.push({ gid: gid });
            localStorage.setItem('order', JSON.stringify(this.orders));
        },
        hasOrder: function () {
            console.log('hasOrder', this.orders);
            return this.orders.length > 0;
        },
        cleanOrders: function () {
            this.orders = [];
            localStorage.removeItem('order');
        }
    },
    getters: {
        isAuthenticated: function (state) { return !!state.user; },
    },
});
